import { gql } from "@apollo/client";

export const CREATE_UPLOAD = gql`
  mutation createUpload($input: CreateUploadInput!) {
    createUpload(input: $input) {
      id
      token
      presignedPutUrl
      publicGetUrl
    }
  }
`;
